let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8SArD")).then(() => parcelRequire('5WXmf'));